/* tslint:disable */
/* eslint-disable */
export enum WorkItemInstallationLocationEnum {
  Aussenaufgestellt = 'Aussenaufgestellt',
  Innenaufgestellt = 'Innenaufgestellt'
}
